import React from "react";
export function PrivacyChoicesButton() {
  return <a className="method-privacy-link" href="https://withmethod.ai/privacy/#tracking">Privacy information</a>;
}
